import { AppProvider } from "./context/context";
import AddSEwithoutPE, { AddSEwithoutPEProps } from "./Add";

const StockEntryAddIndex = ({
  pageType,
  setModalFlag,
}: AddSEwithoutPEProps) => {
  return (
    <AppProvider>
      <AddSEwithoutPE pageType={pageType} setModalFlag={setModalFlag} />
    </AppProvider>
  );
};

export default StockEntryAddIndex;
